import { motion } from "framer-motion";
import Button from "@mui/material/Button";
import Chip from "@mui/material/Chip";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
// import InputLabel from '@mui/material/InputLabel';
// import MenuItem from '@mui/material/MenuItem';
// import FormControl from '@mui/material/FormControl';
// import Select from '@mui/material/Select';
import axios from "axios";
import { useLogin } from "../../contexts/LoginContext";
import { gerarLinkWhatsApp } from "../../utils/WhatsappLink";

const cardVariants = {
    hidden: { opacity: 0, y: 40 },
    visible: (i) => ({
        opacity: 1,
        y: 0,
        transition: { delay: i * 0.3, duration: 0.6, ease: "easeOut" },
    }),
};

const chipVariants = {
    hidden: { opacity: 0, x: -20 },
    visible: (i) => ({
        opacity: 1,
        x: 0,
        transition: { delay: i * 0.1, duration: 0.3, ease: "easeOut" },
    }),
};

const Plans = (props) => {
    const token = localStorage.getItem("token");

    const [hasPlan, setHasPlan] = useState(false);
    const [showButtons, setShowButtons] = useState(false);



    const { fetchLogin } = useLogin()

    useEffect(() => {
        const checkHasPlan = async () => {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/hasPlan`, {
                headers: {
                    Authorization: `${token}`
                }
            });
            if (response.data.status === 200) {
                setHasPlan(true)
            } else {
                setHasPlan(false)
            }
        }
        checkHasPlan()
    }, [token])

    const navigate = useNavigate();
    const scrollRef = useRef(null);

    useEffect(() => {
        const checkScroll = () => {
            if (scrollRef.current) {
                const { scrollWidth, clientWidth } = scrollRef.current;
                setShowButtons(scrollWidth > clientWidth);
            }
        };

        // Checa no início
        checkScroll();

        // Checa sempre que a tela for redimensionada
        window.addEventListener("resize", checkScroll);
        return () => window.removeEventListener("resize", checkScroll);
    }, []); // roda de novo se a lista de planos mudar

    const scrollLeft = () => {
        scrollRef.current.scrollBy({ left: -360, behavior: "smooth" });
    };

    const scrollRight = () => {
        scrollRef.current.scrollBy({ left: 360, behavior: "smooth" });
    };

    const [objPlanos, setObjPlanos] = useState([]);

    useEffect(() => {
        const getPlanos = async () => {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/listarPlanos`);

            setObjPlanos(response.data.planos);
            console.log(response.data.planos);
        }
        getPlanos();
    }, [])

    const plans = [
        {
            id: objPlanos[0]?.idPlano,
            title: objPlanos[0]?.nome,
            height: 700,
            chips: [
                { label: "Faturamento da PJ até: R$ 20.000/mês", icon: <CheckIcon color="success" /> },
                { label: "Composição societária: até 1 sócio", icon: <CheckIcon color="success" /> },
                { label: "Atuação junto a planos de saúde (sob demanda): envio de NF por e-mail e anexos em portais", icon: <CheckIcon color="success" /> },
                { label: "Obrigações fiscais/contábeis: dentro do Simples Nacional", icon: <CheckIcon color="success" /> },
                { label: "Certificado digital incluso: apenas no plano anual", icon: <CheckIcon color="success" /> },
                { label: "Regime tributário: Simples Nacional", icon: <CheckIcon color="success" /> },
                { label: "IRPF sob demanda: até 1 sócio incluso", icon: <CloseIcon color="success" /> },
                { label: "Emissão via Clarea Fácil: até 3 NF/mês", icon: <CloseIcon color="success" /> },
                { label: "Apenas pró-labore do sócio", icon: <CloseIcon color="success" /> },
                { label: "Emissões/mês feitas pela equipe Clarea", icon: <CloseIcon color="error" /> },
                { label: "Folha de pagamento de colaboradores", icon: <CloseIcon color="error" /> },
                { label: "50% de desconto em planejamento patrimonial para até 3 sócios (somente no plano anual)", icon: <CloseIcon color="error" /> },
            ],
            description: objPlanos[0]?.descricao,
            priceOld: objPlanos[0]?.valorAntigoMensal ? Number(objPlanos[0]?.valorAntigoMensal) : "",
            discount: objPlanos[0]?.descontoMensal ? Number(objPlanos[0]?.descontoMensal) : "",
            priceNew: Number(objPlanos[0]?.valorNovoMensal),
            priceOldYear: objPlanos[0]?.valorAntigoAnual ? Number(objPlanos[0]?.valorAntigoAnual) : "",
            priceNewYear: objPlanos[0]?.valorNovoAnual ? Number(objPlanos[0]?.valorNovoAnual) : "",
            discountYear: objPlanos[0]?.descontoAnual ? Number(objPlanos[0]?.descontoAnual) : "",

        },
        {
            id: objPlanos[1]?.idPlano,
            title: objPlanos[1]?.nome,
            height: 700,
            chips: [
                { label: "Faturamento da PJ até: R$ 60.000/mês", icon: <CheckIcon color="success" /> },
                { label: "Composição societária: até 2 sócios", icon: <CheckIcon color="success" /> },
                { label: "Atuação junto a planos de saúde (sob demanda): envio de NF por e-mail e anexos em portais", icon: <CheckIcon color="success" /> },
                { label: "Obrigações fiscais/contábeis: completas dentro do Simples Nacional", icon: <CheckIcon color="success" /> },
                { label: "Certificado digital incluso: apenas no plano anual", icon: <CheckIcon color="success" /> },
                { label: "Regime tributário: Simples Nacional", icon: <CheckIcon color="success" /> },
                { label: "IRPF sob demanda: até 2 sócios inclusos", icon: <CheckIcon color="success" /> },
                { label: "Emissão via Clarea Fácil: ilimitada", icon: <CheckIcon color="success" /> },
                { label: "Pró-labore dos sócios", icon: <CheckIcon color="success" /> },
                { label: "Emissões/mês feitas pela equipe Clarea: até 10", icon: <CheckIcon color="success" /> },
                { label: "Folha de pagamento até 2 colaboradores", icon: <CheckIcon color="success" /> },
                { label: "50% de desconto em planejamento patrimonial para até 3 sócios (somente no plano anual)", icon: <CloseIcon color="error" /> },
            ],
            description: objPlanos[1]?.descricao,
            priceOld: objPlanos[1]?.valorAntigoMensal ? Number(objPlanos[1]?.valorAntigoMensal) : "",
            discount: objPlanos[1]?.descontoMensal ? Number(objPlanos[1]?.descontoMensal) : "",
            priceNew: Number(objPlanos[1]?.valorNovoMensal),
            priceOldYear: objPlanos[1]?.valorAntigoAnual ? Number(objPlanos[1]?.valorAntigoAnual) : "",
            priceNewYear: objPlanos[1]?.valorNovoAnual ? Number(objPlanos[1]?.valorNovoAnual) : "",
            discountYear: objPlanos[1]?.descontoAnual ? Number(objPlanos[1]?.descontoAnual) : "",

        },
        {
            id: objPlanos[2]?.idPlano,
            title: objPlanos[2]?.nome,
            height: 700,
            chips: [
                { label: "Faturamento da PJ até: R$ 150.000/mês", icon: <CheckIcon color="success" /> },
                { label: "Composição societária: até 3 sócios", icon: <CheckIcon color="success" /> },
                { label: "Atuação junto a planos de saúde (sob demanda): envio de NF por e-mail e anexos em portais", icon: <CheckIcon color="success" /> },
                { label: "Obrigações fiscais/contábeis: completas dentro do Simples Nacional", icon: <CheckIcon color="success" /> },
                { label: "Certificado digital incluso: apenas no plano anual", icon: <CheckIcon color="success" /> },
                { label: "Regime tributário: Simples Nacional", icon: <CheckIcon color="success" /> },
                { label: "IRPF sob demanda: até 3 sócios inclusos", icon: <CheckIcon color="success" /> },
                { label: "Emissão via Clarea Fácil: ilimitada", icon: <CheckIcon color="success" /> },
                { label: "Pró-labore dos sócios", icon: <CheckIcon color="success" /> },
                { label: "Emissões/mês feitas pela equipe Clarea: até 20", icon: <CheckIcon color="success" /> },
                { label: "Folha de pagamento: até 3 colaboradores", icon: <CheckIcon color="success" /> },
                { label: "50% de desconto em planejamento patrimonial para até 3 sócios (somente no plano anual)", icon: <CloseIcon color="error" /> },
            ],
            description: objPlanos[2]?.descricao,
            priceOld: objPlanos[2]?.valorAntigoMensal ? Number(objPlanos[2]?.valorAntigoMensal) : "",
            discount: objPlanos[2]?.descontoMensal ? Number(objPlanos[2]?.descontoMensal) : "",
            priceNew: Number(objPlanos[2]?.valorNovoMensal),
            priceOldYear: objPlanos[2]?.valorAntigoAnual ? Number(objPlanos[2]?.valorAntigoAnual) : "",
            priceNewYear: objPlanos[2]?.valorNovoAnual ? Number(objPlanos[2]?.valorNovoAnual) : "",
            discountYear: objPlanos[2]?.descontoAnual ? Number(objPlanos[2]?.descontoAnual) : "",

        },
        {
            id: objPlanos[3]?.idPlano,
            title: objPlanos[3]?.nome,
            height: 700,
            chips: [
                { label: "Faturamento da PJ até: R$ 400.000/mês (R$ 4,8 milhões/ano – teto do Simples Nacional)", icon: <CheckIcon color="success" /> },
                { label: "Composição societária: até 3 sócios", icon: <CheckIcon color="success" /> },
                { label: "Atuação junto a planos de saúde (sob demanda): envio de NF por e-mail e anexos em portais", icon: <CheckIcon color="success" /> },
                { label: "Obrigações fiscais/contábeis: completas dentro do Simples Nacional", icon: <CheckIcon color="success" /> },
                { label: "Certificado digital incluso: apenas no plano anual", icon: <CheckIcon color="success" /> },
                { label: "Regime tributário: Simples Nacional", icon: <CheckIcon color="success" /> },
                { label: "IRPF sob demanda: até 3 sócios inclusos", icon: <CheckIcon color="success" /> },
                { label: "Emissão via Clarea Fácil: ilimitada", icon: <CheckIcon color="success" /> },
                { label: "Pró-labore dos sócios", icon: <CheckIcon color="success" /> },
                { label: "Emissões/mês feitas pela equipe Clarea: até 30", icon: <CheckIcon color="success" /> },
                { label: "Folha de pagamento: até 5 colaboradores", icon: <CheckIcon color="success" /> },
                { label: "50% de desconto em planejamento patrimonial para até 3 sócios (somente no plano anual)", icon: <CheckIcon color="success" /> },
            ],
            description: objPlanos[3]?.descricao,
            priceOld: objPlanos[3]?.valorAntigoMensal ? Number(objPlanos[3]?.valorAntigoMensal) : "",
            discount: objPlanos[3]?.descontoMensal ? Number(objPlanos[3]?.descontoMensal) : "",
            priceNew: Number(objPlanos[3]?.valorNovoMensal),
            priceOldYear: objPlanos[3]?.valorAntigoAnual ? Number(objPlanos[3]?.valorAntigoAnual) : "",
            priceNewYear: objPlanos[3]?.valorNovoAnual ? Number(objPlanos[3]?.valorNovoAnual) : "",
            discountYear: objPlanos[3]?.descontoAnual ? Number(objPlanos[3]?.descontoAnual) : "",

        },
        {
            id: objPlanos[4]?.idPlano,
            title: objPlanos[4]?.nome,
            height: 700,
            chips: [
                { label: "Estrutura adaptada a regimes Lucro Presumido ou Lucro Real", icon: <CheckIcon color="success" /> },
                { label: "Planejamento tributário e societário completo", icon: <CheckIcon color="success" /> },
                { label: "Consultoria contábil e estratégica personalizada", icon: <CheckIcon color="success" /> },
                { label: "Suporte dedicado e reuniões sob demanda", icon: <CheckIcon color="success" /> },
                // { label: "Atendimento online ilimitado", icon: <CheckIcon color="success" /> },
                // { label: "IRPF de até 2 sócios", icon: <CheckIcon color="success" /> },
                // { label: "Onboarding até 10 dias úteis", icon: <CheckIcon color="success" /> },
                // { label: "Folha de pagamento personalizada", icon: <CheckIcon color="success" /> },
            ],
            description: objPlanos[4]?.descricao,
            priceOld: objPlanos[4]?.valorAntigoMensal ? Number(objPlanos[4]?.valorAntigoMensal) : "",
            discount: objPlanos[4]?.descontoMensal ? Number(objPlanos[4]?.descontoMensal) : "",
            priceNew: Number(objPlanos[4]?.valorNovoMensal),
            priceOldYear: objPlanos[4]?.valorAntigoAnual ? Number(objPlanos[4]?.valorAntigoAnual) : "",
            priceNewYear: objPlanos[4]?.valorNovoAnual ? Number(objPlanos[4]?.valorNovoAnual) : "",
            discountYear: objPlanos[4]?.descontoAnual ? Number(objPlanos[4]?.descontoAnual) : "",

        }
    ];

    const HandleChoosePlan = (id, title, description, price, priceYear, periodicity) => {
        if (!token) {
            navigate("/Cadastro");
        }

        if (hasPlan) {
            navigate("../Dashboard/Assinatura");
            return;
        } else {
            console.log({ id, title, description, price, priceYear, periodicity });
            if (periodicity === "mensal") {
                localStorage.setItem("planoSelecionado", JSON.stringify({ id, title, description, price, periodicity }));
            } else {
                localStorage.setItem("planoSelecionado", JSON.stringify({ id, title, description, price: priceYear, periodicity }));
            }
            if (token) {
                fetchLogin();
                navigate("../AssinarContrato");
            } else {
                navigate("/Cadastro");
            }
            return;
        }

    }

    const [periodicity, setPeriodicity] = useState("anual");

    const handleChange = (event) => {
        setPeriodicity(event.target.value);
    };

    return (
        <section style={{ width: "100%", backgroundColor: "#f5f5f5", padding: "40px 0" }}>
            <div style={{ width: "90%", margin: "0 auto", textAlign: "center" }}>
                <h2 style={{ margin: "20px 0" }}>{props.title}</h2>
                <div
                    className="scroll-buttons"
                    style={{
                        display: showButtons ? "flex" : "none",
                        justifyContent: "center",
                        margin: "20px 0",
                        gap: "10px",
                    }}
                >
                    <Button onClick={scrollLeft} variant="contained" sx={{
                        padding: "14px 28px",
                        fontSize: "1rem",
                        backgroundColor: "#ffc845",
                        color: "#0b243d",
                        borderRadius: "10px",
                        boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
                        transition: "0.3s ease",
                        '&:hover': {
                            backgroundColor: "#e6b53e",
                            transform: "scale(1.05)",
                        },
                    }}>
                        ◀
                    </Button>
                    <Button onClick={scrollRight} variant="contained" sx={{
                        padding: "14px 28px",
                        fontSize: "1rem",
                        backgroundColor: "#ffc845",
                        color: "#0b243d",
                        borderRadius: "10px",
                        boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
                        transition: "0.3s ease",
                        '&:hover': {
                            backgroundColor: "#e6b53e",
                            transform: "scale(1.05)",
                        },
                    }}>
                        ▶
                    </Button>
                </div>

                <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
                    <div
                        ref={scrollRef}
                        style={{
                            display: "flex",
                            // justifyContent: "center",
                            gap: "20px",
                            overflowX: "auto",
                            scrollSnapType: "x mandatory",
                            paddingBottom: "20px",
                            scrollbarWidth: "none",
                            msOverflowStyle: "none",
                        }}
                    >
                        {plans.map((plan, i) => (
                            <motion.div
                                key={i}
                                custom={i}
                                variants={cardVariants}
                                initial="hidden"
                                whileInView="visible"
                                viewport={{ once: true, amount: 0.3 }}
                                style={{
                                    width: "90vw",
                                    maxWidth: "360px",
                                    flex: "0 0 auto",
                                    scrollSnapAlign: "start",
                                    border: "1px solid #ccc",
                                    borderRadius: "30px",
                                    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                    padding: "34px 10px",
                                    backgroundColor: "#f9f2e4",
                                }}
                            >
                                {plan.recommended ? (
                                    <div
                                        style={{
                                            width: "80%",
                                            margin: "0 auto 10px",
                                            backgroundColor: "#0b243d",
                                            color: "white",
                                            borderRadius: "10px",
                                            padding: "5px",
                                            fontWeight: "bold",
                                            textAlign: "center",
                                        }}
                                    >
                                        RECOMENDADO
                                    </div>
                                ) : (
                                    <div style={{ marginBottom: "20px" }}></div>
                                )}

                                <h1 style={{ textAlign: "center" }}>{plan.title}</h1>
                                <p style={{ fontSize: "12px", marginBottom: "10px" }}>{plan.description}</p>
                                <div style={{ display: "flex", justifyContent: "center" }}>
                                    <div style={{ height: "25px", width: "fit-content", display: "flex", alignItems: "center", justifyContent: "center", gap: "5px" }}>
                                        {periodicity === "mensal" ?
                                            (
                                                plan?.priceOld ? (
                                                    <p style={{ fontSize: "15px", marginRight: "5px", textDecoration: "line-through" }}>
                                                        {plan?.priceOld?.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                    </p>
                                                ) : ""
                                            )
                                            : (
                                                plan?.priceOldYear ? (
                                                    <p style={{ fontSize: "15px", marginRight: "5px", textDecoration: "line-through" }}>
                                                        {plan?.priceOldYear?.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                    </p>
                                                ) : ""
                                            )
                                        }

                                    </div>
                                    {periodicity === "mensal" ? (
                                        plan.discount > 0 ? (
                                            <p
                                                style={{
                                                    fontSize: "13px",
                                                    backgroundColor: "#0b243d",
                                                    padding: "2px 6px",
                                                    borderRadius: "8px",
                                                    color: "#fff",
                                                    fontWeight: "bold",
                                                    display: "inline-block",
                                                }}
                                            >{`${plan.discount}% OFF`}</p>
                                        ) : ""

                                    ) : (
                                        plan.discountYear > 0 ? (
                                            <p
                                                style={{
                                                    fontSize: "13px",
                                                    backgroundColor: "#0b243d",
                                                    padding: "2px 6px",
                                                    borderRadius: "8px",
                                                    color: "#fff",
                                                    fontWeight: "bold",
                                                    display: "inline-block",
                                                }}
                                            >{`${plan.discountYear}% OFF`}</p>
                                        ) : ""
                                    )}

                                    {/* <p
                                    style={{
                                        fontSize: "13px",
                                        backgroundColor: "#0b243d",
                                        padding: "2px 6px",
                                        borderRadius: "8px",
                                        color: "#fff",
                                        fontWeight: "bold",
                                        display: "inline-block",
                                    }}
                                >
                                    {plan.discount || plan.discountYear
                                        ? `${periodicity === "mensal" ? parseInt(plan.discountYear) : plan.discountYear}% OFF`
                                        : "—"}
                                </p> */}

                                </div>
                                {plan.title === "Plus Personalizado" ? (
                                    <p style={{ fontSize: "25px" }}>
                                        <strong>Sob consulta</strong>
                                    </p>
                                ) : (
                                    <p style={{ fontSize: "25px" }}>
                                        <strong> <b style={{ fontSize: "12px", fontWeight: "normal" }}>POR</b> R$ {periodicity === "mensal" ? plan.priceNew.toFixed(2).replace(".", ",") : parseFloat(plan.priceNewYear)?.toFixed(2).replace(".", ",")}<b style={{ fontSize: "12px", fontWeight: "normal" }}>/Mês</b></strong>
                                    </p>
                                )}
                                <div style={{ display: "flex", justifyContent: "center", padding: "20px 0" }}>
                                    <div>
                                        <FormControl fullWidth sx={{ mb: 2, maxWidth: "150px" }} size="small" >
                                            <InputLabel>Selecione</InputLabel>
                                            <Select
                                                value={periodicity}
                                                label="Periodicity"
                                                onChange={handleChange}
                                            >
                                                <MenuItem value={"mensal"}>Mensal</MenuItem>
                                                <MenuItem value={"anual"}>Anual</MenuItem>
                                            </Select>
                                        </FormControl>
                                        {/* { id: 1, name: "Serviço Contábil A", desc: "Descrição do Serviço A", price: 250 }, */}
                                        {plan.title === "Plus Personalizado" ? (
                                            <Button onClick={() => window.open(gerarLinkWhatsApp("Olá, tenho interesse no plano *Plus Personalizado* (Sob Consulta). Poderia me enviar mais informações?"))} variant="contained" sx={{
                                                padding: "14px 28px",
                                                fontSize: "1rem",
                                                backgroundColor: "#ffc845",
                                                color: "#0b243d",
                                                borderRadius: "10px",
                                                boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
                                                transition: "0.3s ease",
                                                '&:hover': {
                                                    backgroundColor: "#e6b53e",
                                                    transform: "scale(1.05)",
                                                },
                                            }}>
                                                assinar plano
                                            </Button>
                                        ) : (
                                            <Button onClick={() => HandleChoosePlan(plan.id, plan.title, plan.description, plan.priceNew, plan.priceNewYear, periodicity)} variant="contained" sx={{
                                                padding: "14px 28px",
                                                fontSize: "1rem",
                                                backgroundColor: "#ffc845",
                                                color: "#0b243d",
                                                borderRadius: "10px",
                                                boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
                                                transition: "0.3s ease",
                                                '&:hover': {
                                                    backgroundColor: "#e6b53e",
                                                    transform: "scale(1.05)",
                                                },
                                            }}>
                                                assinar plano
                                            </Button>
                                        )}
                                    </div>
                                </div>
                                <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                                    {plan.chips.map((chip, idx) => (
                                        <motion.div
                                            key={idx}
                                            custom={idx}
                                            variants={chipVariants}
                                            initial="hidden"
                                            whileInView="visible"
                                            viewport={{ once: true, amount: 0.3 }}
                                        >
                                            <Chip
                                                sx={{
                                                    height: "auto",
                                                    border: "none",
                                                    "& .MuiChip-label": { display: "block", whiteSpace: "normal" },
                                                }}
                                                icon={chip.icon}
                                                label={chip.label}
                                                variant="outlined"
                                            />
                                        </motion.div>
                                    ))}
                                </div>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Plans;
